<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="bankAlias" >
        <span slot="label" >
          <a-tooltip>
            {{$t('银行简称')}}
            <template slot="title">
              如:中国农业银行
            </template>
            <a-icon type="question-circle" />
          </a-tooltip>
        </span>
        <a-input v-model="form.bankAlias" :maxLength="32" :placeholder="$t('请输入')+$t('银行简称')" />
      </a-form-model-item>
      <a-form-model-item  prop="bankName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('银行名称')}}
            <template slot="title">
              如:中国农业银行
            </template>
            <a-icon type="question-circle" />
          </a-tooltip>
        </span>
        <a-input v-model="form.bankName" :maxLength="32" :placeholder="$t('请输入')+$t('银行名称')" />
      </a-form-model-item>
      <a-form-model-item prop="bankCode" >
        <span slot="label" >
          <a-tooltip>
            {{$t('银行编码')}}
            <template slot="title">
              如:中国农业银行的银行编码是 ABC
            </template>
            <a-icon type="question-circle" />
          </a-tooltip>
        </span>
        <a-input v-model="form.bankCode" :maxLength="32" :placeholder="$t('请输入')+$t('银行编码')" />
      </a-form-model-item>
      <a-form-model-item prop="bankIcon" >
        <span slot="label" >
          <a-tooltip>
            {{$t('图标')}}
            <template slot="title">
               {{$t('图标')}}
            </template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.bankIcon" type="img"></oss-upload-single>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getBranch, addBranch, updateBranch, getBank} from '@/api/merchant/branch'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle";

import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {cityListTree} from "@/api/logistics";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    OssUploadSingle
  },
  data () {
    return {
      cityList: [],
      citySelected: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        code: null,
        clearingCode: undefined,
        name: null,

        bankAlias: null,

        bankName: null,

        bankCode: null,

        cityCode: null,

        cityName: null,

        provinceCode: null,

        provinceName: null,
        bankIcon: null,
        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        code: [
          { required: true, message: this.$t('联行号')+this.$t('不能为空'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('银行全名')+this.$t('不能为空'), trigger: 'blur' }
        ],
        bankAlias: [
          { required: true, message: this.$t('银行简称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('银行名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: this.$t('银行编码')+this.$t('不能为空'), trigger: 'blur' }
        ],
        cityCode: [
          { required: true, message: this.$t('城市code')+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.citySelected=[]
      this.formType = 1
      this.form = {
        id: null,
        code: null,
        clearingCode: undefined,
        name: null,
        bankAlias: null,
        bankName: null,
        bankCode: null,
        cityCode: null,
        cityName: null,
        provinceCode: null,
        provinceName: null,
        bankIcon:null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBank({"id":id}).then(response => {
        this.form = response.data
        //回显出分类
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateBranch(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addBranch(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(
                  message,
                  3
                );
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
